function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*jshint esversion: 6 */
import { CustomFormBuilder } from "./Helpers/CustomFormBuilder";
import { DropdownBuilder } from "./Helpers/DropdownBuilder";
import { FormManager } from "./Helpers/FormManager";
import { InnerPageBuilder } from "./Helpers/InnerPageBuilder";
import { CustomFormApiService } from "./Services/CustomFormApiService";
import { HouseholdApiService } from "./Services/HouseholdApiService";
import { UserService } from "./Services/UserService";
import { ComponentBase } from "./Shared/ComponentBase";
import { I18N } from "./Shared/I18n";
export var MppCustomForm = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppCustomForm, _ComponentBase);

  var _super = _createSuper(MppCustomForm);

  function MppCustomForm() {
    var _this;

    _classCallCheck(this, MppCustomForm);

    _this = _super.call(this);
    _this._completeMessage = null;
    return _this;
  }

  _createClass(MppCustomForm, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      if (!!this._$detailsContainer) {
        this.loadAttributes();
        this.LoadCustomForm();
      }
    }
  }, {
    key: "loadAttributes",
    value: function loadAttributes() {
      this.formGuid = this.getAttribute("formguid") || null;
    } // istanbul ignore next

  }, {
    key: "createI18N",
    value: function createI18N() {
      return new I18N("mpp-custom-form");
    }
  }, {
    key: "getCustomFormService",
    value: function getCustomFormService() {
      return new CustomFormApiService();
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var i18n, urlFormGuid;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.createI18N();

              case 3:
                i18n = _context.sent;
                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);

                if (_context.t0.toString().startsWith("TypeError")) {
                  this._root.innerHTML = "Unable to connect.  Please check Permitted URLs.";
                } else {
                  this._root.innerHTML = "".concat(_context.t0);
                }

                return _context.abrupt("return");

              case 10:
                this._i18n = i18n; /// Get attributes

                this.loadAttributes();
                this._currentUrl = new URL(window.location.href);
                urlFormGuid = this._currentUrl.searchParams.get("id");

                if (!this.formGuid) {
                  this.formGuid = urlFormGuid;
                }

                if (this.formGuid) {
                  _context.next = 18;
                  break;
                }

                this._root.innerHTML = this._i18n.missingFormGuidMessage;
                return _context.abrupt("return");

              case 18:
                this.BindHtmlElements();
                this._customFormService = this.getCustomFormService();
                _context.next = 22;
                return UserService.GetCurrentUser().then(function (userInfo) {
                  _this2._userInfo = userInfo;
                }, function () {
                  _this2._$updateMyInfoContainer.style.display = "none";
                });

              case 22:
                /// Get custom form and bind event listeners
                this.LoadCustomForm();

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }() // istanbul ignore next

  }, {
    key: "BindHtmlElements",
    value: function BindHtmlElements() {
      /// Set root innerHTML
      ///
      this._root.innerHTML =  `<link href="${this._appRoot}/Content/mppw-widgetstyles.css" rel="stylesheet" type="text/css"/><div class="mppw-component-container"><div id="pageLoadingContainer" style="display: none;"><i class="mppw-spinner"></i></div><div id="detailsContainer"></div><div class="mppw-form-wrapper"><h1 id="customFormTitle" class="mpp-mt-0"></h1></div><div class="mpp-innerpage"><p id="customFormDescription"></p></div><div class="mpp-form--container" id="formContainer" style="display: none"><form id="customForm" class="mppw-form mppw-form-validate"><input type="hidden" id="field_formId" name="Field_FormId"/> <input type="hidden" id="saveContactInfo" name="SaveContactInfo"/> <input type="hidden" id="saveAddressInfo" name="SaveAddressInfo"/><div id="formHeader"></div><div id="personalDetails"><div class="mppw-row"><div class="mppw-col"><h3>Personal Details</h3></div></div><div class="mppw-row"><div class="mppw-col"><div id="completeFormAsContainer" class="mppw-form-field mppw-form-field__static-container"><select name="ContactId" id="completeFormAs" class="mppw-form-field__control" value=""></select> <label class="mppw-form-field__label" for="completeFormAs">Complete Form As*:</label></div></div></div></div><h4 id="updateContactWarningMessage" style="display: none;">${this._i18n.updateContactWarningMessage}</h4><h4 id="updateAddressWarningMessage" style="display: none;">${this._i18n.updateAddressWarningMessage}</h4><div id="contactFormContainer"></div><div id="addressFormContainer"></div><div id="formFields"></div><div id="updateMyInfoContainer" class="mppw-form-field"><br/><label class="mpp-card-multiselect--checkbox-small"><input type="checkbox" id="inquire_updateMyInfo" name="updateMyInfo"/> <span style="float: left;"></span></label> <label class="mpp-updatemyinfo--checkboxlabel" for="inquire_updateMyInfo">${this._i18n.updateMyInfoLabel}</label></div><input type="submit" class="mppw-btn primary mpp-mt-10 submit--btn" id="submitButton" value="${this._i18n.submitButtonLabel}"/></form></div><div id="resultMessageContainer" class="mppw-alert" style="display: none;"><div class="mppw-alert__icon"></div><span id="resultMessageText" class="mppw-alert__text"></span></div></div>` ; /// Set up attribute bindings
      ///

      this._$formContainer = this._root.querySelector("#formContainer");
      this._$pageLoadingContainer = this._root.querySelector("#pageLoadingContainer");
      this._$customFormContainer = this._root.querySelector("#customForm");
      this._$detailsContainer = this._root.querySelector("#detailsContainer");
      this._$contactFormContainer = this._root.querySelector("#contactFormContainer");
      this._$addressFormContainer = this._root.querySelector("#addressFormContainer"); // Error/success message elements

      this._$resultMessageContainer = this._root.querySelector("#resultMessageContainer");
      this._$resultMessageText = this._root.querySelector("#resultMessageText");
      this._$fieldformId = this._root.querySelector("#field_formId");
      this._$saveContactInfo = this._root.querySelector("#saveContactInfo");
      this._$saveAddressInfo = this._root.querySelector("#saveAddressInfo");
      this._$formFields = this._root.querySelector("#formFields");
      this._$completeFormAs = this._root.querySelector("#completeFormAs");
      this._$completeFormAsContainer = this._root.querySelector("#completeFormAsContainer");
      this._$personalDetailsContainer = this._root.querySelector("#personalDetails");
      this._$contactDetailsDiv = null;
      this._$addressDetailsDiv = null;
      this._$customFormTitle = this._root.querySelector("#customFormTitle");
      this._$customFormDescription = this._root.querySelector("#customFormDescription");
      this._$updateContactWarningMessage = this._root.querySelector("#updateContactWarningMessage");
      this._$updateAddressWarningMessage = this._root.querySelector("#updateAddressWarningMessage");
      this._$updateMyInfoContainer = this._root.querySelector("#updateMyInfoContainer");
      this._$updateMyInfo = this._root.querySelector("#inquire_updateMyInfo"); // Address fields

      this._$addressLine1 = null;
      this._$addressLine2 = null;
      this._$addressCity = null;
      this._$addressState = null;
      this._$addressPostalCode = null;
      this._$submitButton = this._root.querySelector("#submitButton");
    } // istanbul ignore next

  }, {
    key: "getHouseholdApiService",
    value: function getHouseholdApiService() {
      return new HouseholdApiService();
    } // Get logged in user and bind dropdown values, only if Get_Contact_Info is true for the form

  }, {
    key: "DoForLoggedInUser",
    value: function DoForLoggedInUser() {
      var _this3 = this;

      var householdService = this.getHouseholdApiService();
      householdService.GetHouseholdMembers().then(function (members) {
        if (!!members && members.length > 0) {
          _this3._householdMembers = members;
          var allMembers = members.map(function (member) {
            return {
              id: member.contactId,
              value: member.displayName
            };
          }); // Load family member dropdowns

          _this3.ShowCompleteFormAs();

          DropdownBuilder.LoadDropdown(_this3._$completeFormAs, allMembers, "Blank Form");
          _this3._$completeFormAs.value = _this3._userInfo.contactId;

          _this3.DisplayElements(true, _this3._$contactDetailsDiv); // Pre-populate fields when logged in


          _this3.PopulateContactFields(_this3._userInfo.contactId);

          _this3.PopulateAddressFields(_this3._userInfo.contactId);
        } else {
          _this3.HideCompleteFormAs();
        }
      });
    } // Gets the custom form data based on formGuid attribute

  }, {
    key: "LoadCustomForm",
    value: function LoadCustomForm() {
      var _this4 = this;

      this.DisplayElements(true, this._$pageLoadingContainer); // Load form data:

      return this._customFormService.GetForm(this.formGuid).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
          var _this4$_customFormDat, _this4$_customFormDat2;

          var isExpired;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this4._$detailsContainer.innerHTML = "";
                  isExpired = data.isExpired;
                  _this4._customFormData = data;
                  _this4._completeMessage = (_this4$_customFormDat = (_this4$_customFormDat2 = _this4._customFormData.formData) === null || _this4$_customFormDat2 === void 0 ? void 0 : _this4$_customFormDat2.Complete_Message) !== null && _this4$_customFormDat !== void 0 ? _this4$_customFormDat : null;

                  if (!(isExpired === true)) {
                    _context2.next = 8;
                    break;
                  }

                  _this4.SetMessage("warning", _this4._i18n.formExpiredMessage);

                  _context2.next = 10;
                  break;

                case 8:
                  _context2.next = 10;
                  return _this4.RenderForm(data.formData, data.formConfiguration);

                case 10:
                  _this4.DisplayElements(false, _this4._$pageLoadingContainer);

                  if (_this4._customFormData.formData.Force_Login && !_this4._userInfo) {
                    _this4._$submitButton.style.display = "none";
                    _this4._$contactFormContainer.style.display = "none";
                    _this4._$addressFormContainer.style.display = "none";
                  }

                  _this4._$updateMyInfoContainer.style.display = "none";

                  if (_this4._userInfo && (_this4._getContactInfo || _this4._getAddressInfo)) {
                    _this4._$updateMyInfoContainer.style.display = "block";
                  }

                case 14:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }())["catch"](function (error) {
        console.error(error);

        _this4.DisplayElements(false, _this4._$pageLoadingContainer);
      });
    }
  }, {
    key: "RenderForm",
    value: function () {
      var _RenderForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dataToRender, formConfiguration) {
        var Form_ID, Form_Title, Get_Contact_Info, Get_Address_Info, DefaultImageUrl, Instructions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                Form_ID = dataToRender.Form_ID, Form_Title = dataToRender.Form_Title, Get_Contact_Info = dataToRender.Get_Contact_Info, Get_Address_Info = dataToRender.Get_Address_Info, DefaultImageUrl = dataToRender.DefaultImageUrl, Instructions = dataToRender.Instructions;
                this._getContactInfo = Get_Contact_Info;
                this._getAddressInfo = Get_Address_Info;
                this.DrawFormHeader(DefaultImageUrl, Form_Title, Form_ID, Instructions);
                _context3.next = 6;
                return this.DrawFormFields(formConfiguration);

              case 6:
                if (this._userInfo) {
                  if (this._getAddressInfo) {
                    this.PopulateAddressFields(this._userInfo.contactId);
                  }
                }

                this.BindEventListeners(); // Need to initially disable and hide any fields that depend on another fields value

                CustomFormBuilder.DisableAllDependsOnInputs(this._root);
                this.customForm = new FormManager(this._$customFormContainer);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function RenderForm(_x2, _x3) {
        return _RenderForm.apply(this, arguments);
      }

      return RenderForm;
    }()
  }, {
    key: "DrawFormHeader",
    value: function DrawFormHeader(imageUrl, formTitle, formId, instructions) {
      // Draw form header
      this._$fieldformId.value = formId;
      this._$saveContactInfo.value = this._getContactInfo;
      this._$saveAddressInfo.value = this._getAddressInfo;
      var detailsContainerHTML = "";
      detailsContainerHTML += InnerPageBuilder.BuildInnerPageDetails(!!imageUrl ? InnerPageBuilder.BuildImage(imageUrl, "") : "");
      this._$detailsContainer.innerHTML += detailsContainerHTML;
      this._$customFormTitle.innerHTML += formTitle || "";
      this._$customFormDescription.innerHTML += instructions || "";
    }
  }, {
    key: "DrawFormFields",
    value: function () {
      var _DrawFormFields = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(formConfiguration) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return CustomFormBuilder.RenderCustomForm(this.formGuid, this._$formFields, this._root, true, !!this._userInfo);

              case 2:
                this.DrawContactInfoFields();
                this.DrawAddressFields(formConfiguration);
                this.DisplayElements(true, this._$formContainer);
                this.DisplayElements(false, this._$pageLoadingContainer);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function DrawFormFields(_x4) {
        return _DrawFormFields.apply(this, arguments);
      }

      return DrawFormFields;
    }()
  }, {
    key: "DrawAddressFields",
    value: function DrawAddressFields(formConfiguration) {
      if (this._getAddressInfo == true) {
        // Find usa
        var usa = formConfiguration.countries.find(function (element) {
          return element.value == "United States of America";
        }); // Insert into 0 position

        formConfiguration.countries.splice(0, 0, usa);
        CustomFormBuilder.DrawAddressForm(this._i18n, this._$addressFormContainer, formConfiguration.countries);
        this._$addressDetailsDiv = this._root.querySelector("#addressDetailsDiv");
        this._$addressLine1 = this._root.querySelector("#addressLine1");
        this._$addressLine2 = this._root.querySelector("#addressLine2");
        this._$addressCity = this._root.querySelector("#city");
        this._$addressState = this._root.querySelector("#stateRegion");
        this._$addressPostalCode = this._root.querySelector("#postalCode");
      }
    }
  }, {
    key: "DrawContactInfoFields",
    value: function DrawContactInfoFields() {
      if (!!this._getContactInfo) {
        CustomFormBuilder.DrawContactForm(this._i18n, this._$contactFormContainer);
        this._$contactDetailsDiv = this._root.querySelector("#contactDetailsDiv");
        this._$firstName = this._root.querySelector("#firstName");
        this._$lastName = this._root.querySelector("#lastName");
        this._$emailAddress = this._root.querySelector("#emailAddress");
        this._$mobilePhone = this._root.querySelector("#mobilePhone"); // If user is logged in

        if (this._userInfo) this.DoForLoggedInUser();else this.HideCompleteFormAs();
      } else {
        this.HideCompleteFormAs();
      }
    }
  }, {
    key: "BindEventListeners",
    value: function BindEventListeners() {
      var _this5 = this;

      this._$submitButton.addEventListener("click", function (event) {
        event.preventDefault();

        if (_this5.customForm.IsValid()) {
          // Disable button on submit
          _this5._$submitButton.setAttribute("disabled", "disabled"); // Set button submitting text


          _this5._$submitButton.value = "Submitting..."; // Display page loading indicator

          _this5.DisplayElements(true, _this5._$pageLoadingContainer); // Set Form data


          var formData = new FormData(_this5._$customFormContainer);
          formData.set("updateMyInfo", _this5._$updateMyInfo.checked); // Post form data

          _this5._postFormData(formData);
        } else {
          _this5.SetMessage("warning", _this5._i18n.validationFailedMessage);
        }
      });

      this._$completeFormAs.addEventListener("change", function (e) {
        // Only show blank form if drop down value is null
        if (!!_this5._$completeFormAs.value) {
          var selectedContactId = _this5._$completeFormAs.value;

          _this5.DisplayElements(true, _this5._$contactDetailsDiv); // Populate fields for selected contact


          _this5.PopulateAddressFields(selectedContactId);

          _this5.PopulateContactFields(selectedContactId);
        } else {
          // Show fields
          _this5.DisplayElements(true, _this5._$contactDetailsDiv);

          _this5.PopulateContactFields();

          _this5.PopulateAddressFields();
        }
      });
    }
  }, {
    key: "_postFormData",
    value: function _postFormData(formData) {
      var _this6 = this;

      return this._customFormService.PostFormData(formData).then(function (resp) {
        if (resp) {
          _this6.DisplayElements(false, _this6._$formContainer, _this6._$detailsContainer, _this6._$pageLoadingContainer, _this6._$customFormTitle, _this6._$customFormDescription);

          var successMessage = _this6._completeMessage || _this6._i18n.completeMessage;

          _this6.SetMessage("success", successMessage);

          _this6._$submitButton.removeAttribute("disabled");

          _this6._$submitButton.value = _this6._i18n.submitButtonLabel; // Reset form

          _this6.customForm.Reset();
        } else {
          _this6.SetMessage("danger", _this6._i18n.customFormErrorMessage);

          _this6._$submitButton.removeAttribute("disabled");

          _this6._$submitButton.value = _this6._i18n.submitButtonLabel;
        }
      })["catch"](function (err) {
        var exceptionMessage = " ";

        if (!!err) {
          if (err.message === "MISSING-CONTACT-INFO") {
            exceptionMessage += _this6._i18n.customFormMissingContactInfo;
          }

          if (err.message === "MISSING-ADDRESS-INFO") {
            exceptionMessage += _this6._i18n.customFormMissingAddressInfo;
          }
        }

        _this6.SetMessage("danger", _this6._i18n.customFormErrorMessage + exceptionMessage);

        _this6._$submitButton.removeAttribute("disabled");

        _this6._$submitButton.value = _this6._i18n.submitButtonLabel;

        _this6.DisplayElements(false, _this6._$pageLoadingContainer);
      });
    } // Populate address fields based on contact id

  }, {
    key: "PopulateAddressFields",
    value: function PopulateAddressFields(contactId) {
      var _this7 = this;

      if (!this._getAddressInfo) {
        return;
      }

      if (!!contactId) {
        return this._customFormService.GetContactById(contactId).then(function (resp) {
          if (!!resp) {
            if (resp.address) {
              var addressInfo = resp.address;
              _this7._$addressLine1.value = addressInfo.addressLine1;
              _this7._$addressLine2.value = addressInfo.addressLine2;
              _this7._$addressCity.value = addressInfo.city;
              _this7._$addressState.value = addressInfo.stateRegion;
              _this7._$addressPostalCode.value = addressInfo.postalCode;
            }
          }
        })["catch"](function (err) {
          console.error("Unable to get default address info for selected contact.");
        });
      } else {
        this._$addressLine1.value = "";
        this._$addressLine2.value = "";
        this._$addressCity.value = "";
        this._$addressState.value = "";
        this._$addressPostalCode.value = "";
      }
    } // Shows or hides the element(s) passed in
    // Example: this.DisplayElements(true, this._$formContainer, this._$pageLoadingContainer);

  }, {
    key: "DisplayElements",
    value: function DisplayElements() {
      var display = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      for (var _len = arguments.length, elements = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        elements[_key - 1] = arguments[_key];
      }

      for (var _i = 0, _elements = elements; _i < _elements.length; _i++) {
        var element = _elements[_i];

        if (element) {
          // Get all inputs for the given div
          var inputElements = element.getElementsByTagName("input");

          if (display === true) {
            // Display div
            element.style.display = "block"; // Remove the disabled attribute that was set below

            var _iterator = _createForOfIteratorHelper(inputElements),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var el = _step.value;
                el.removeAttribute("disabled");
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          } else {
            // Hide div
            element.style.display = "none"; // Add disabled to prevent form validation issues on hidden inputs

            var _iterator2 = _createForOfIteratorHelper(inputElements),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _el = _step2.value;

                _el.setAttribute("disabled", true);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        }
      }
    }
  }, {
    key: "SetMessage",
    value: function SetMessage(status, message) {
      this._$resultMessageContainer.classList.remove("mppw-alert__success");

      this._$resultMessageContainer.classList.remove("mppw-alert__info");

      this._$resultMessageContainer.classList.remove("mppw-alert__warning");

      this._$resultMessageContainer.classList.remove("mppw-alert__danger");

      this._$resultMessageContainer.classList.add("mppw-alert__".concat(status));

      this._$resultMessageText.innerHTML = message;
      this._$resultMessageContainer.style.display = "";
    }
  }, {
    key: "ShowCompleteFormAs",
    value: function ShowCompleteFormAs() {
      this.DisplayElements(true, this._$personalDetailsContainer);
    }
  }, {
    key: "HideCompleteFormAs",
    value: function HideCompleteFormAs() {
      this.DisplayElements(false, this._$personalDetailsContainer);
    }
  }, {
    key: "GetHouseHoldMemberByContactId",
    value: function GetHouseHoldMemberByContactId(contactId) {
      if (!!contactId && !!this._householdMembers) {
        return this._householdMembers.find(function (h) {
          return h.contactId === +contactId;
        });
      }

      return null;
    }
  }, {
    key: "PopulateContactFields",
    value: function PopulateContactFields(contactId) {
      if (!!contactId) {
        var houseHoldContact = this.GetHouseHoldMemberByContactId(contactId);
        this._$firstName.value = houseHoldContact.firstName;
        this._$lastName.value = houseHoldContact.lastName;
        this._$emailAddress.value = houseHoldContact.emailAddress;
        this._$mobilePhone.value = houseHoldContact.mobilePhoneNumber;
      } else {
        this._$firstName.value = "";
        this._$lastName.value = "";
        this._$emailAddress.value = "";
        this._$mobilePhone.value = "";
      }
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["formguid"];
    }
  }]);

  return MppCustomForm;
}(ComponentBase); // Use spine-case as convention for element name:

MppCustomForm.registerComponent("mpp-custom-form", MppCustomForm);